import React, { useEffect, useState } from "react";
import { Modal } from "reactstrap";
import { getValue } from "@utils/lodash";
import { sanitizeInput } from "@_common/dompurify";

function AuditorCommentModal(props: any) {
  const {
    requestAC,
    setRequestAC,
    handleModalAC,
    isACOpen,
    submitUserLoading,
    handleSubmitAuditorComment,
    selectedAuditorComments,
  } = props;

  const [error, setError] = useState<boolean>(false);

  const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    const sanitizedValue = sanitizeInput(e.target.value);
    setRequestAC({
      ...requestAC,
      auditor_comments: sanitizedValue,
    });
  };

  useEffect(() => {
    if (selectedAuditorComments) {
      setRequestAC({
        auditor_comments: selectedAuditorComments,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedAuditorComments]);

  const handleSubmit = () => {
    if (!requestAC?.auditor_comments?.trim()) {
      setError(true);
      return;
    }
    setError(false);
    handleSubmitAuditorComment();
  };

  const handleCloseModal = () => {
    setError(false);
    handleModalAC();
  };

  return (
    <div>
      <Modal isOpen={isACOpen} className="modal-xs" centered>
        <div className="dropdown-menu-change_owner">
          <p className="header-text">Auditor Comment</p>

          <div className="modal-grid grid-body m-0">
            <div className="w-100 mb-3">
              <label htmlFor="state">Add Auditor Comments *</label>
              <textarea
                placeholder="Enter Auditor Comments"
                className="w-100 compelte-task-wrapper__text-area"
                rows={3}
                value={getValue(requestAC, `auditor_comments`, "")}
                onChange={handleChange}
              ></textarea>
              {error && (
                <span className="text-danger">
                  Auditor Comment is mandatory
                </span>
              )}
            </div>
          </div>

          <div className="d-flex justify-content-end">
            <button
              className="ascent-button ascent-button--header-buttons ascent-button--primary"
              onClick={handleCloseModal}
            >
              Cancel
            </button>
            <button
              className="ascent-button ascent-button--header-buttons ascent-button--secondary"
              onClick={handleSubmit}
            >
              {submitUserLoading ? "Please wait..." : selectedAuditorComments? "Update":"Submit"}
            </button>
          </div>
        </div>
      </Modal>
    </div>
  );
}

export default AuditorCommentModal;
